<footer class="footer">
  <p class="first">Copyright 2021 - UST Global ©</p>
  <p>All rigths reserved.</p>
  <p>Version {{ appVersion }}</p>
</footer>
